<template>
  <v-autocomplete
    v-show="hideWhenEmpty ? keepShowing || cupItems.length > 0 : true"
    v-model="selectedCups"
    v-show-fade="{ isFilter: isFilter }"
    :items="cupItems"
    :label="labelCup"
    :loading="$apollo.queries.cups.loading"
    v-bind="{ ...$attrs, returnObject, multiple }"
    :search-input.sync="keyword"
    :no-filter="!customSearchable"
    :menu-props="menuProperties"
    item-text="name"
    item-value="id"
    :data-test="dataTest"
    append-icon="$iconSearch"
    :dense="dense"
    :class="[selectMixinClass]"
    hide-no-data
    :clearable="clearable"
    outlined
    :hide-details="hideDetails"
    @change="changeHandler"
    @focus="focused"
    @blur="blurHandler"
  />
</template>
<script>
import gql from "fraql";
import selectsMixin from "./selects_mixin";
import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
import { compact } from "lodash-es";
import * as JsSearch from "js-search";
export default {
  name: "AppSelectCups",
  mixins: [selectsMixin],
  props: {
    value: {
      type: [Object, String, Array],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    disciplineIds: {
      type: Array,
      default: () => []
    },
    hideWhenEmpty: {
      type: Boolean,
      default: false
    },
    hideInactives: {
      type: Boolean,
      default: false
    },
    customSearchable: {
      type: Boolean,
      default: true
    },
    groupByDisciplines: {
      type: Boolean,
      default: false
    },
    dataTest: {
      type: String,
      default: "cups"
    },
    dense: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {
      ...useDisciplineHelper()
    };
  },
  data() {
    return {
      cups: [],
      menuProperties: {},
      keyword: null
    };
  },
  computed: {
    // prevent input being hidden because there are no cups found by search
    keepShowing() {
      if (this.hideWhenEmpty) {
        return this.keyword && this.keyword.length > 0;
      }

      return false;
    },
    labelCup() {
      return this.$t(
        "common:cups.filter.label",
        "Cups",
        "Default label for cups selection element"
      );
    },
    cupItems() {
      if (!compact(this.cups)) {
        return [];
      }

      let cups = this.cups.filter(cup => {
        if (this.hideInactives && cup.status != "active") {
          if (typeof this.value === "string") {
            return this.value == cup.id;
          } else if (this.multiple && Array.isArray(this.value)) {
            return !!this.value.find(c => {
              if (this.returnObject) return c.id == cup.id;
              return c == cup.id;
            });
          } else if (this.returnObject) {
            return this.value && this.value.id == cup.id;
          }
          return false;
        }
        return true;
      });

      if (this.customSearchable && this.keyword && this.keyword.length > 0) {
        const s = new JsSearch.Search("id");
        s.addIndex("name");
        s.addDocuments(cups);
        cups = s.search(this.keyword);
      }

      if (this.isFilter || this.groupByDisciplines) {
        if (this.disciplineIds.length > 0) {
          cups = cups.filter(x => this.disciplineIds.includes(x.disciplineId));
        }
        const grouped = [];
        this.disciplinesTranslated.forEach(d => {
          const val = cups.filter(c => c.disciplineId == d.id);
          if (val.length > 0) {
            grouped.push({ header: d.i18n });
            grouped.push({ divider: true });

            grouped.push(val);
          }
        });
        cups = grouped.flat();
      } else if (this.disciplineIds.length > 0) {
        cups = cups.filter(x => this.disciplineIds.includes(x.disciplineId));
      }

      return cups;
    },
    selectedCups: {
      get() {
        return this.value;
      },
      set(vals) {
        this.$emit("input", vals);
      }
    }
  },
  methods: {
    changeHandler(evt) {
      this.inputVisibility(evt, "change");
    },
    blurHandler(evt) {
      this.keyword = "";
      this.inputVisibility(evt);
    }
  },
  apollo: {
    cups: {
      query: gql`
        query cups {
          cups {
            id
            name
            status
            disciplineId
          }
        }
      `,
      fetchPolicy: "cache-first"
    }
  }
};
</script>
